import { View } from "@-/com.npmjs.react-native";
import { MorphemeGlyphTilePinyinDot } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.tile.ui._components.pinyin-dot";
import type { MorphemeGlyphTilePinyinDotsGate } from "#get-morpheme-glyph-tile-pinyin-dots-gate";

/** Matches `MORPHEME_FRONT_BUTTON_PINYIN_DOTS_ROW_HEIGHT` in card-front glyph sizing. */
const PINYIN_DOTS_ROW_CLASSNAME = "h-1.5 w-full shrink-0 flex-row items-end justify-center gap-0.5";

/** A tile's pinyin-dots row. Only `getMorphemeGlyphTilePinyinDotsGate` decides whether it shows. */
export function MorphemeGlyphTilePinyinDots({
  gate,
}: {
  gate: MorphemeGlyphTilePinyinDotsGate;
}) {
  return (
    <View className={PINYIN_DOTS_ROW_CLASSNAME}>
      {gate.additionalPinyinList.map((pinyin, index) => (
        <MorphemeGlyphTilePinyinDot key={`${pinyin}-${index}`} pinyin={pinyin} />
      ))}
    </View>
  );
}
